export default "__VITE_ASSET__901603fc__"